import { sessionTransition } from './session-transition';

const destinationKey = 'ra-auth-destination';
const authPath = /^\/(sign-in|sign-up|forgot-password|sso-callback|session-tasks|api)(\/|$)/;

export const safeAuthDestination = (value?: string | null): string => {
  if (!value) {
    return '/account/';
  }
  try {
    const url = new URL(value, window.location.origin);
    const pathname = decodeURIComponent(url.pathname);
    if (url.origin !== window.location.origin || url.username || url.password || pathname.startsWith('//') || pathname.includes('\\') || authPath.test(pathname)) {
      return '/account/';
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return '/account/';
  }
};

export const rememberAuthDestination = (destination: string) => {
  try {
    sessionStorage.setItem(destinationKey, safeAuthDestination(destination));
  } catch {
    // Query parameters still carry the destination when browser storage is unavailable.
  }
};

export const readAuthDestination = (resume = false): string => {
  const query = new URLSearchParams(window.location.search);
  const explicit = query.get('return_to') ?? query.get('redirect_url');
  if (explicit !== null) {
    return safeAuthDestination(explicit);
  }
  if (resume) {
    try {
      return safeAuthDestination(sessionStorage.getItem(destinationKey));
    } catch {
      return '/account/';
    }
  }
  return '/account/';
};

export const authRoute = (route: string, destination: string, resume = false) => {
  const query = new URLSearchParams({ return_to: safeAuthDestination(destination) });
  if (resume) {
    query.set('resume', '1');
  }
  return `${route}?${query}`;
};

export const completeAuthNavigation = (destination: string, decorateUrl: (url: string) => string) => {
  try {
    sessionStorage.removeItem(destinationKey);
  } catch {
    // Navigation does not depend on browser storage.
  }
  sessionTransition.navigate(decorateUrl(safeAuthDestination(destination)));
};
